import { render, staticRenderFns } from "./Stockistrecord.vue?vue&type=template&id=0f2a3ada&scoped=true"
import script from "./Stockistrecord.vue?vue&type=script&lang=js"
export * from "./Stockistrecord.vue?vue&type=script&lang=js"
import style0 from "./Stockistrecord.vue?vue&type=style&index=0&id=0f2a3ada&prod&scoped=true&lang=css"
import style1 from "./Stockistrecord.vue?vue&type=style&index=1&id=0f2a3ada&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2a3ada",
  null
  
)

export default component.exports